import { defineMessages } from "react-intl";
import { defaultFormMessages } from "../shared/crud/form";

export const campingMapMessages = defineMessages({
  ...defaultFormMessages,
  entityName: {
    id: "campingMap.title.default",
    defaultMessage: "Camping Map",
  },
  saveSuccess: {
    id: "campingMap.save.success",
    defaultMessage: "Guardado correctamente",
  },
  enabledLabel: {
    id: "campingMap.field.enabled",
    defaultMessage: "Enabled",
  },
  baseUrlLabel: {
    id: "campingMap.field.baseUrl",
    defaultMessage: "Base URL",
  },
  selectionModeLabel: {
    id: "campingMap.field.selectionMode",
    defaultMessage: "Selection Mode",
  },
  OPTIONAL: {
    id: "campingMap.selectionMode.optional",
    defaultMessage: "Optional",
  },
  MANDATORY: {
    id: "campingMap.selectionMode.mandatory",
    defaultMessage: "Mandatory",
  },
  chargeSelectionLabel: {
    id: "campingMap.field.chargeSelection",
    defaultMessage: "Charge Selection",
  },
  selectionExpirationMinutesLabel: {
    id: "campingMap.field.selectionExpirationMinutes",
    defaultMessage: "Selection Expiration (minutes)",
  },
  accommodationConfigLabel: {
    id: "campingMap.field.accommodationConfig",
    defaultMessage: "Accommodations",
  },
  accommodationConfigHelpText: {
    id: "campingMap.field.accommodationConfig.helpText",
    defaultMessage: "Select the accommodations where the camping map will be enabled",
  },
});
